










import { Component, Prop, Emit } from "vue-property-decorator";
import LanguageManager from "@/LanguageManager";
import { HtmlOptionInfo } from "@/@types/window";
import TaskProcessor from "@/app/core/task/TaskProcessor";
import { Task, TaskResult } from "task";
import CtrlRadio from "@/app/core/component/CtrlRadio.vue";
import LifeCycle from "@/app/core/decorator/LifeCycle";
import { Mixins } from "vue-mixin-decorator";
import ComponentVue from "@/app/core/window/ComponentVue";

@Component({
  components: { CtrlRadio }
})
export default class BackgroundTypeRadio extends Mixins<ComponentVue>(
  ComponentVue
) {
  @Prop({ type: String, default: "image" })
  public value!: string;

  @Prop({ type: Boolean, default: false })
  private test!: boolean;

  @Emit("input")
  public input(value: string | null) {}

  private get localValue(): string | null {
    if (this.test)
      window.console.log("set '" + this.value + "'", this.constructor.name);
    return this.value || "";
  }

  private set localValue(value: string | null) {
    if (this.test)
      window.console.log("return '" + value + "'", this.constructor.name);
    this.input(value);
  }

  private optionInfoList: HtmlOptionInfo[] = [
    { value: "image", key: "", text: "", disabled: false },
    { value: "color", key: "", text: "", disabled: false }
  ];

  @LifeCycle
  private created() {
    this.createOptionInfoList();
  }

  @TaskProcessor("language-change-finished")
  private async languageChangeFinished(
    task: Task<never, never>
  ): Promise<TaskResult<never> | void> {
    this.createOptionInfoList();
    task.resolve();
  }

  private createOptionInfoList() {
    this.optionInfoList.forEach(o => {
      o.text = this.$t(`label.${o.value}`)!.toString();
      o.key = o.value || "";
    });
  }

  public focus() {
    const elm = this.$refs.component as CtrlRadio;
    elm.focus();
  }
}
